import { call, all, takeLatest, put } from 'redux-saga/effects';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import getDataFromResponse from '../utils/get-data-from-res';
import { fetchFeedbacks, IInsertFeedbackPayload } from './feedback.actions';

function* insertFeedbackAsync({
    payload: { data },
}: {
    payload: IInsertFeedbackPayload;
}) {
    yield getFetchInstance().post(`feedbackquiz/insert`, data);
}

function* fetchFeedbacksAsync() {
    const res = yield getFetchInstance().get('feedbackquiz/view');
    const feedbacks = getDataFromResponse(res);
    yield put(
        fetchFeedbacks({
            feedbacks,
        })
    );
}

function* watchInsertFeedback() {
    yield takeLatest(
        createFetchSagaPattern('INSERT_FEEDBACK'),
        createFetchFunction('INSERT_FEEDBACK', insertFeedbackAsync)
    );
}

function* watchFetchFeedbacks() {
    yield takeLatest(
        createFetchSagaPattern('FEEDBACKS'),
        createFetchFunction('FEEDBACKS', fetchFeedbacksAsync)
    );
}

export default function* feedbackSagas() {
    yield all([call(watchFetchFeedbacks), call(watchInsertFeedback)]);
}
